import { CONTACT_POINT_SYSTEM, REGEX_EXPS } from "utils/constants";
import { normalizeTextField } from "utils/helpers/validations";
import * as yup from "yup";

const validation = (errors) => {
  const requiredString = yup
    .string()
    .typeError(errors.REQUIRED)
    .required(errors.REQUIRED);
  const textField = yup
    .string()
    .transform(normalizeTextField)
    .typeError(errors.REQUIRED)
    .required(errors.REQUIRED);
  const optionalTextField = yup
    .string()
    .transform(normalizeTextField)
    .nullable();

  return yup.object().shape({
    telecoms: yup.object().shape({
      [CONTACT_POINT_SYSTEM.CITY]: yup.object().shape({
        value: requiredString,
      }),
      [CONTACT_POINT_SYSTEM.ADDRESS]: yup.object().shape({
        value: textField,
      }),
      [CONTACT_POINT_SYSTEM.ADDRESS_LOCATION]: yup.object().shape({
        value: optionalTextField,
      }),
      [CONTACT_POINT_SYSTEM.COMPLEMENT]: yup.object().shape({
        value: optionalTextField,
      }),
      [CONTACT_POINT_SYSTEM.RESIDENCE]: yup.object().shape({
        value: optionalTextField,
      }),
      [CONTACT_POINT_SYSTEM.ZIP_CODE]: yup.object().shape({
        value: yup
          .string()
          .typeError(errors.REQUIRED)
          .required(errors.REQUIRED)
          .test("isValid", errors.INVALID_VALUE, async function (value) {
            const isValidRegex = new RegExp(REGEX_EXPS.zipCode).test(value);
            return isValidRegex;
          }),
      }),
    }),
  });
};

export default validation;
